var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentEmailErrorFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 132,
    viewBox: "0 0 139 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1405 74.4973C49.5321 79.9011 56.04 82.9976 62.9973 82.9976C64.4624 82.9976 65.6514 81.8085 65.6514 80.3434C65.6514 78.8784 64.4624 77.6893 62.9973 77.6893C57.6466 77.6893 52.6392 75.3042 49.2596 71.1496C45.8801 66.995 44.5849 61.5311 45.7031 56.1592C47.0939 49.4956 52.5012 44.0883 59.1612 42.701C64.5226 41.5757 69.99 42.8744 74.1481 46.2576C78.3062 49.6371 80.6914 54.6445 80.6914 59.9952V64.4188C80.6914 65.8838 79.4988 67.0729 78.0373 67.0729C76.5758 67.0729 75.3832 65.8838 75.3832 64.4188V60.0631C75.3833 60.0405 75.3834 60.0179 75.3834 59.9952C75.3834 59.9726 75.3833 59.95 75.3832 59.9273V50.2635C75.3832 48.7984 74.1941 47.6094 72.7291 47.6094C71.9733 47.6094 71.2909 47.9258 70.8074 48.4334C70.2957 48.9705 69.388 49.3625 68.731 49.018C67.0158 48.1185 65.065 47.6094 62.9975 47.6094C56.1676 47.6094 50.6116 53.1653 50.6116 59.9952C50.6116 66.8252 56.1676 72.3811 62.9975 72.3811C65.8779 72.3811 68.5317 71.3929 70.6377 69.7378C71.1179 69.3605 71.8275 69.4337 72.2465 69.8779C73.6997 71.4184 75.7588 72.3811 78.0373 72.3811C82.4254 72.3811 85.9996 68.8104 85.9996 64.4188V59.9952C85.9996 53.0415 82.8996 46.53 77.4959 42.1419C72.0956 37.7502 65.0109 36.0587 58.0748 37.5061C49.3799 39.3179 42.32 46.3779 40.5046 55.0763C39.0608 62.0159 40.7488 69.0935 45.1405 74.4973ZM70.075 59.9442V60.0463C70.0474 63.9262 66.8838 67.0729 62.9975 67.0729C59.0942 67.0729 55.9199 63.8986 55.9199 59.9952C55.9199 56.0919 59.0942 52.9176 62.9975 52.9176C66.8838 52.9176 70.0474 56.0643 70.075 59.9442Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 59.8818C14 32.9291 35.9291 11 62.8818 11C89.836 11 111.764 32.9291 111.764 59.8818C111.764 71.4107 107.752 82.0199 101.051 90.3871C100.728 90.7905 100.754 91.3736 101.12 91.739L123.678 114.297C125.441 116.059 125.441 118.917 123.678 120.678C122.797 121.559 121.642 122 120.488 122C119.333 122 118.179 121.559 117.298 120.678L94.7395 98.1194C94.3741 97.7539 93.791 97.728 93.3876 98.0511C85.0203 104.752 74.4109 108.764 62.8818 108.764C35.9291 108.764 14 86.836 14 59.8818ZM23.0243 59.882C23.0243 81.8593 40.9046 99.7395 62.8818 99.7395C84.859 99.7395 102.739 81.859 102.739 59.8818C102.739 37.9046 84.859 20.0243 62.8818 20.0243C40.9046 20.0243 23.0243 37.9048 23.0243 59.882Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.7283,
    y1: 44.2871,
    x2: 48.4761,
    y2: 94.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -15.6124,
    y1: 28.585,
    x2: 34.4569,
    y2: 148.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentEmailErrorFp);
export default __webpack_public_path__ + "static/media/sentEmailErrorFP.40d2078b1d0b7d06341a0f975d0dd059.svg";
export { ForwardRef as ReactComponent };